import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '欧美大片推荐',
    url: 'https://www.oumeidapian.com/',
    description: '致力于为广大影迷提供最新、最全的欧美大片推荐与观影指南。涵盖动作、科幻、悬疑、爱情等多种类型，助你发现每一部值得观看的好电影。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@oumeidapian.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />
      <main className="pt-20 md:pt-24 pb-14 md:pb-20">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <section className="mb-14 md:mb-20">
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-8">
              关于<span className="text-primary-500">我们</span>
            </h1>

            <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-4">品牌介绍</h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                <strong>欧美大片推荐</strong>成立于2020年，是国内领先的欧美电影推荐与资讯平台。我们专注于为华语影迷提供最新、最全面的好莱坞及欧美电影推荐服务，内容覆盖<strong>动作大片</strong>、<strong>科幻巨制</strong>、<strong>悬疑惊悚</strong>、<strong>爱情经典</strong>等多种热门类型。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们的编辑团队由资深影迷和专业影评人组成，每周更新大量原创内容，包括新片推荐、经典回顾、深度解析、观影指南等。无论是寻找周末观影选择，还是深入了解电影背后的故事，欧美大片推荐都是你最值得信赖的伙伴。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                我们秉持客观、专业的态度，每一部推荐电影都经过团队成员的认真筛选和讨论，确保为读者提供最具价值的观影建议。让每一位影迷都能在这里找到属于自己的那份光影感动，是我们不变的初心。
              </p>
            </div>
          </section>

          <section className="mb-14 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-8 text-center">
              我们的<span className="text-accent-500">口碑</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-user-star-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-4xl md:text-5xl font-bold font-heading text-accent-500">50万<span className="text-base font-normal text-foreground-500">+</span></h3>
                <p className="text-sm text-foreground-600 mt-2">月活跃影迷用户</p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-movie-2-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-4xl md:text-5xl font-bold font-heading text-primary-500">2000<span className="text-base font-normal text-foreground-500">+</span></h3>
                <p className="text-sm text-foreground-600 mt-2">精选推荐电影</p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-article-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="text-4xl md:text-5xl font-bold font-heading text-secondary-500">500<span className="text-base font-normal text-foreground-500">+</span></h3>
                <p className="text-sm text-foreground-600 mt-2">深度原创影评</p>
              </div>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  "欧美大片推荐是我每周必看的网站。他们的影评既有深度又不失趣味，帮我发现了很多之前错过的宝藏电影。分类导航也很方便，想找什么类型的电影一目了然。"
                </p>
                <p className="text-xs text-foreground-500 font-medium">—— 影迷 张先生</p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  "作为一个科幻片爱好者，这里的科幻分类做得太好了。从经典到最新，每部推荐都很精准。IMDb排行的整理也很有参考价值，已成为我的观影指南。"
                </p>
                <p className="text-xs text-foreground-500 font-medium">—— 科幻迷 李女士</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-8 text-center">
              联系<span className="text-primary-500">我们</span>
            </h2>
            <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@oumeidapian.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-wechat-line text-lg text-accent-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900 mb-1">微信公众号</h3>
                    <p className="text-sm text-foreground-600">欧美大片推荐</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-weibo-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900 mb-1">新浪微博</h3>
                    <p className="text-sm text-foreground-600">@欧美大片推荐官方</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-bilibili-line text-lg text-accent-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900 mb-1">哔哩哔哩</h3>
                    <p className="text-sm text-foreground-600">欧美大片推荐</p>
                  </div>
                </div>
              </div>
              <div className="mt-8 pt-8 border-t border-background-200/70">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  如果你有任何关于欧美大片的观影问题、合作意向或内容建议，欢迎通过以上方式联系我们。我们的团队会在24小时内回复你的消息。感谢你对欧美大片推荐的支持与信任！
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}